import { MfaActionTypes, MfaState } from './mfa.types';

const initialState = {
  status: 'pending',
  error: '',
  data: {}
} as MfaState;

// eslint-disable-next-line @typescript-eslint/default-param-last
const mfaReducer = (state = initialState, action: MfaActionTypes): typeof initialState => {
  switch (action.type) {
    case 'MFA_INFO_SUCCESS': {
      return {
        ...state,
        status: 'idle',
        data: action.payload
      };
    }

    case 'MFA_SMS_VERIFY_SUCCESS': {
      return {
        ...state,
        data: {
          ...state.data,
          phoneNumber: action.payload,
          smsFactorAvailable: true
        }
      };
    }

    case 'MFA_SMS_DISABLE_SUCCESS': {
      return {
        ...state,
        data: {
          ...state.data,
          phoneNumber: null,
          smsFactorAvailable: false
        }
      };
    }

    case 'MFA_SMS_VERIFY_FAILURE':
    case 'MFA_TOTP_VERIFY_FAILURE': {
      return {
        ...state,
        error: action.error
      };
    }

    case 'MFA_TOTP_VERIFY_SUCCESS': {
      return {
        ...state,
        data: {
          ...state.data,
          totpFactorAvailable: true
        }
      };
    }

    case 'MFA_TOTP_DISABLE_SUCCESS': {
      return {
        ...state,
        data: {
          ...state.data,
          totpFactorAvailable: false
        }
      };
    }

    case 'MFA_SET_ERROR': {
      return {
        ...state,
        error: action.payload
      };
    }

    default:
      return state;
  }
};

export default mfaReducer;
